import { create } from '@terminal/utils/store/createStore';

export interface WatchlistManagerStore {
  shouldResetList?: boolean;
  isAddMode?: boolean;
  isEditMode?: boolean;
  onConfirmCallback?: () => void;
  setIsAddMode: (isAddMode?: boolean) => void;
  setIsEditMode: (isEditMode?: boolean) => void;
  setOnConfirmCallback: (onConfirmCallback?: () => void) => void;
  setShouldResetList: (shouldResetList?: boolean) => void;
}

export const useWatchlistManagerWidget = create<WatchlistManagerStore>(set => ({
  setIsAddMode: isAddMode => set({ isAddMode }),
  setIsEditMode: isEditMode => set({ isEditMode }),
  setOnConfirmCallback: onConfirmCallback => set({ onConfirmCallback }),
  setShouldResetList: shouldResetList => set({ shouldResetList }),
}));
